import React, { useEffect, useState } from "react";
import { Spinner, UncontrolledCarousel } from "reactstrap";
import "yet-another-react-lightbox/styles.css";
import "./BilingualProjectImages.css"; // External CSS for styling

const BilingualProjectImages = () => {
  const [images, setImages] = useState([]); // Array of objects containing both thumbnail and full-size image
  const [loading, setLoading] = useState(true); // Loading state

  // Function to import images and wait for them to load
  function importImages(r) {
    return r.keys().map((key) => ({ src: r(key) })); // Convert to [{ src: "image.jpg" }]
  }

  // Function to preload images
  const preloadImages = (imageUrls) => {
    return Promise.all(
      imageUrls.map((image) => {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.src = image.src;
          img.onload = () => resolve(image);
          img.onerror = (error) => {
            resolve(null); // Resolve with null to avoid breaking Promise.all
          };
        });
      })
    ).then((results) => results.filter((image) => image !== null)); // Filter out failed images
  };

  useEffect(() => {
    const loadImages = async () => {
      setLoading(true); // Start loading

      let imagesArray = [];


      const imagesThumbnailArray = importImages(
        require.context(
          "../../assets/RealEnglishImages/TheBilingualProject/ThumbnailTheBilingualProject",
          false,
          /\.(png|jpeg|jpg)$/
        )
      );

      imagesArray = imagesThumbnailArray.map((thumbnail, index) => ({
        thumbnail: thumbnail.src,
      }));

      // Preload images and wait for them to load
      try {
        await preloadImages(imagesArray);
        setImages(imagesArray);
      } catch (error) {
        console.error("Error loading images:", error);
      } finally {
        setLoading(false); // Stop loading
      }
    };

    loadImages();
  }, []);

  // Transform images for UncontrolledCarousel
  const carouselItems = images.map((image) => ({
    src: image.thumbnail, // Use the thumbnail URL
    altText: "Bilingual Project Image", // Add a descriptive alt text
    caption: "", // Optional: Add a caption if needed
    header: "", // Optional: Add a header if needed
  }));

  return (
    <section >
      {/* Loader */}
      {loading ? (
        <div className="text-center mt-5">
          <Spinner color="primary" /> Loading images...
        </div>
      ) : (
        <div className="live-preview carousel-container">
          <UncontrolledCarousel
            interval={4000} // Set the interval between slides (in milliseconds)
            items={carouselItems} // Pass the transformed images array
          />
        </div>
      )}

    </section>
  );
};

export default BilingualProjectImages;